const saude = ['Médico', 'Enfermeiro', 'Fisioterapeuta', 'Dentista']
const engenharia = ['Engenheiro']
const direito = ['Advogado']

const texto = {

    profisionaisSaude (id) {
        return `<div class="texto" style="text-align:justify; margin-bottom: 0">Seguro de responsabilidade civil que protege ${saude[id]} e outros profissionais da saúde, com coberturas que respeitam as necessidades específicas desses profissionais, no exercício de suas funções.</div>`
    },

    profisionaisEngenharia () {
        return `<div class="texto" style="text-align:justify;">Proteja o seu patrimônio, proteja sua Obra!</div>
                <div class="texto" style="text-align:justify;">A responsabilidade civil do engenheiro decorre da possibilidade de causar danos a terceiros. Ele é um dos profissionais liberais que corre muitos riscos no exercício da profissão. Basta que um projeto esteja errado para que um acidente ocorra.
                Conviver com essa incerteza a todo o momento pode ser muito complicado. Por isso, o seguro de responsabilidade civil do engenheiro é uma excelente opção para minimizar esses riscos e dá segurança no dia a dia de trabalho.</div>
                <div class="texto" style="text-align:justify;">Podemos dizer que a responsabilidade civil do engenheiro se divide em responsabilidade:</div>
                <ul>
                    <li style="list-style:inside;text-indent: 40px;"><b style="font-weight:bold;">Contratual:</b> o profissional tem a obrigação de executar determinado trabalho conforme contrato;</li><br>
                    <li style="list-style:inside;text-indent: 40px;"><b style="font-weight:bold;">Pela solidez e segurança da construção:</b> o engenheiro responde pela solidez e segurança da obra por 5 anos. Mas, diante de erro do profissional, ele será responsabilizado independentemente do prazo transcorrido;</li><br>
                    <li style="list-style:inside;text-indent: 40px;"><b style="font-weight:bold;">Pelos materiais:</b> o engenheiro responde pela escolha dos materiais a serem empregados na obra ou serviço. Por isso, é feita a especificação desses materiais em “Memorial Descritivo”;</li><br>
                    <li style="list-style:inside;text-indent: 40px;"><b style="font-weight:bold;">Por danos a terceiros:</b> o engenheiro deve tomar providências para preservar a segurança, a saúde e o sossego de terceiros. Em caso de danos a vizinhos, como em fundações, vibração de estaqueamentos, quedas de materiais e outros, ele responderá.</li>
                </ul><br>
                <div class="texto" style="text-align:justify;">Fazemos a Consultoria e de acordo com sua Especialidade orientamos o melhor produto de acordo com a sua necessidade de cobertura.</div>`
    },

    profisionaisDireito () {
        return `<div class="texto" style="text-align:justify;">Proteja sua carreira, dê tranquilidade para sua família e segurança ao seu patrimônio.</div>
                <div class="texto" style="text-align:justify;">Responsabilidade em relação ao cliente, perda de prazo, perda de chance, erro na tese de defesa, quebra de sigilo profissional do cliente, erros de cálculo em valores processuais, indenização perdas e danos à imagem e outras mais, conte a com proteção do
                seguro para lhe dar segurança e tranquilidade, cobrindo inclusive os custos de processos.</div><br>
                <div class="texto" style="text-align:justify;font-family: 'Quattrocento', serif;">Fazemos a Consultoria e de acordo com sua Especialidade orientamos o melhor produto de acordo com a sua necessidade de cobertura.</div>`
    },

    profissao (p) {

        if (saude.includes(p)) {
           return this.profisionaisSaude(saude.indexOf(p))
        } else if (engenharia.includes(p)) {
            return this.profisionaisEngenharia()
        } else if (direito.includes(p)) {
            return this.profisionaisDireito()
        } else {
            return '';
        }
    },

    existe_profissao (p) {
        let dados = saude.concat(engenharia).concat(direito)
        if (dados.includes(p)) {
            return true
        } else {
            return false
        }
    }

}

export default texto;



// WEBPACK FOOTER //
// ./src/helpers/texto-profissao.js